export default "__VITE_ASSET__DO4KEx_C__"